// extracted by mini-css-extract-plugin
export default {"container":"styles_container__NzGsq","card":"styles_card__C4bsP","selecionado":"styles_selecionado__6osyq","numero":"styles_numero__tuZTT","label":"styles_label__7HBzi"};